<div class="mx-auto h-full flex flex-column align-items-center justify-content-center text-center	">
    <img src="./assets/icons/card-slash.svg" alt="Card slash" class="mb-4 md:mb-6" />
    <h2 class="text-3xl md:text-5xl font-semibold mb-4 mt-2" data-clarity-unmask="true">Twoja płatność się nie powiodła</h2>
    <p class="text-lg md:text-xl mb-6">Ponów płatność teraz lub spróbuj później. </p>
    <p class="text-base mb-2	">Jeśli błąd nadal będzie się pojawiał skontaktuj się z Nami.</p>
    <div class="flex flex-wrap gap-4 sm:gap-6 align-items-center justify-content-center text-center">
        <div class="flex flex-wrap gap-2 align-items-center mb-2">
            <i class="pi pi-envelope text-lg font-medium text-bluegray-500"></i>
            <p> support&#64;zdamyprawko.pl</p>
        </div>
        <div class="flex flex-wrap gap-2 align-items-center">
            <i class="pi pi-phone text-lg font-medium text-bluegray-500"></i>
            <p>+48 000-000-000</p>
        </div>
    </div>
    <div class="flex flex-wrap gap-4 mt-6 align-items-center justify-content-center">
        <p-button label="Powrót do zamówienia" [outlined]="true" (onClick)="goToBuySubscriptionsModal(null)" [disabled]="loading" data-clarity-unmask="true"></p-button>
        <p-button label="Ponów płatność" icon="pi pi-arrow-right" iconPos="right" (onClick)="renewOskSubscriptionsTransaction()" [loading]="loading" data-clarity-unmask="true"></p-button>
    </div>
</div>
